import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    curretMenuIndex:'',
  },
  mutations: {
    setCurretMenuIndex(state,value){
      state.curretMenuIndex = value
    }
  },
  actions: {
  },
  modules: {
  }
})
